import { createSlice } from '@reduxjs/toolkit';
import {
  GoldenCard,
  MergedPackageModel,
  MyOrderListModel,
  PurchaseSteps,
  Subscription,
  UserPackageModel
} from '../views/Marketplace/Maeketplace.types';
import {
  getTravelPackages,
  getTravelutionSubscriptions,
  getSaveAndTravelSubscriptions,
  purchasePackage,
  purchaseSubscription,
  getGoldenCard,
  getTravelutionSubscriptionBundle,
  purchaseGoldenCard,
  purchaseEventTickets,
  getGoldenCardStatus,
  purchaseSubscriptionBundle,
  getSaveAndTravelInit,
  getSaveAndTravelSubscriptionInit,
  setPurchaseCardStep,
  setOrderId,
  getSuperSalesLicences,
  getSuperSalesSubscriptions,
  purchaseSuperSales,
  getEventTickets,
  purchaseSaveAndTravelSubscription,
  getAccessPacks,
  purchaseAccessPack
} from '../views/Marketplace/Marketplace.actions';
import { buyVirtualOffice } from '../views/Settings/Settings.actions';

export interface MarketplaceSliceType {
  loading: boolean;
  addHubLoading: boolean;
  currencyType: number;
  hubs: MergedPackageModel[];
  subscriptions: MergedPackageModel[];
  userPackage: UserPackageModel | null;
  subscription: Subscription | null;
  goldenCard: GoldenCard[] | null;
  eventTicket: GoldenCard[] | null;
  subscriptionBundle: Subscription | null;
  saveAndTravelSubscription: Subscription | null;
  saveAndTravelSubscriptionPayload: any;
  superSalesSubscription: Subscription | null;

  goldenCardStatus: string;
  orderId: number;
  step: PurchaseSteps;
}

const initialState = {
  loading: false,
  addHubLoading: false,
  currencyType: 0,
  hubs: [],
  subscriptions: [],
  goldenCard: [],
  eventTicket: [],
  userPackage: null,
  subscription: null,
  subscriptionBundle: null,
  saveAndTravelSubscription: null,
  saveAndTravelSubscriptionPayload: null,
  superSalesSubscription: null,
  orderId: 0,
  goldenCardStatus: '',
  step: PurchaseSteps.PAYMENT_METHOD
} as MarketplaceSliceType;

const marketplaceSlice = createSlice({
  name: 'withdraw',
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder.addCase(getTravelutionSubscriptions.pending, (state) => {
      state.loading = true;
      state.hubs = [];
    });
    builder.addCase(
      getTravelutionSubscriptions.fulfilled,
      (state, { payload }) => {
        state.loading = false;
        state.subscriptions = payload.hubs;
        //state.userPackages = payload.userPackages;
      }
    );

    builder.addCase(getTravelutionSubscriptions.rejected, (state) => {
      state.loading = false;
      state.hubs = [];
    });

    //SAVE AND TRAVEL
    builder.addCase(getSaveAndTravelSubscriptions.pending, (state) => {
      state.loading = true;
      state.hubs = [];
    });
    builder.addCase(
      getSaveAndTravelSubscriptions.fulfilled,
      (state, { payload }) => {
        state.loading = false;
        state.saveAndTravelSubscription = payload.hubs;
      }
    );

    builder.addCase(getSaveAndTravelSubscriptions.rejected, (state) => {
      state.loading = false;
      state.hubs = [];
    });

    builder.addCase(purchaseSaveAndTravelSubscription.pending, (state) => {
      state.addHubLoading = true;
    });
    builder.addCase(
      purchaseSaveAndTravelSubscription.fulfilled,
      (state, { payload }) => {
        state.addHubLoading = false;
      }
    );

    builder.addCase(purchaseSaveAndTravelSubscription.rejected, (state) => {
      state.addHubLoading = false;
    });

    builder.addCase(getSaveAndTravelInit.pending, (state) => {
      state.addHubLoading = true;
      state.hubs = [];
    });
    builder.addCase(getSaveAndTravelInit.fulfilled, (state, { payload }) => {
      state.addHubLoading = false;
      state.saveAndTravelSubscriptionPayload = payload;
    });

    builder.addCase(getSaveAndTravelInit.rejected, (state) => {
      state.addHubLoading = false;
      state.hubs = [];
    });

    // TRAVEL PACKAGES
    builder.addCase(getTravelPackages.pending, (state) => {
      state.loading = true;
      state.hubs = [];
    });
    builder.addCase(getTravelPackages.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.hubs = payload.hubs;
      //state.userPackages = payload.userPackages;
    });

    builder.addCase(getTravelPackages.rejected, (state) => {
      state.loading = false;
    });

    builder.addCase(purchasePackage.pending, (state) => {
      state.addHubLoading = true;
    });
    builder.addCase(purchasePackage.fulfilled, (state, { payload }) => {
      state.addHubLoading = false;
      state.orderId = payload;
    });

    builder.addCase(purchasePackage.rejected, (state) => {
      state.addHubLoading = false;
    });

    // SUBSCRIPTION
    builder.addCase(purchaseSubscription.pending, (state) => {
      state.addHubLoading = true;
    });
    builder.addCase(purchaseSubscription.fulfilled, (state, { payload }) => {
      state.addHubLoading = false;
      state.orderId = payload;
    });

    builder.addCase(purchaseSubscription.rejected, (state) => {
      state.addHubLoading = false;
    });

    builder.addCase(getSaveAndTravelSubscriptionInit.pending, (state) => {
      state.addHubLoading = true;
    });
    builder.addCase(
      getSaveAndTravelSubscriptionInit.fulfilled,
      (state, { payload }) => {
        state.addHubLoading = false;
        state.saveAndTravelSubscriptionPayload = payload;
      }
    );

    builder.addCase(getSaveAndTravelSubscriptionInit.rejected, (state) => {
      state.addHubLoading = false;
    });

    // EVENT TICKETS

    builder.addCase(getEventTickets.fulfilled, (state, { payload }) => {
      state.eventTicket = payload;
    });

    builder.addCase(purchaseEventTickets.pending, (state) => {
      state.addHubLoading = true;
    });
    builder.addCase(purchaseEventTickets.fulfilled, (state, { payload }) => {
      state.addHubLoading = false;
      state.orderId = payload;
    });

    builder.addCase(purchaseEventTickets.rejected, (state) => {
      state.addHubLoading = false;
    });

    // GOLDEN CARD
    builder.addCase(getGoldenCardStatus.fulfilled, (state, { payload }) => {
      state.goldenCardStatus = payload;
    });

    builder.addCase(getGoldenCard.fulfilled, (state, { payload }) => {
      state.goldenCard = payload;
    });

    builder.addCase(purchaseGoldenCard.pending, (state) => {
      state.addHubLoading = true;
    });
    builder.addCase(purchaseGoldenCard.fulfilled, (state, { payload }) => {
      state.addHubLoading = false;
      state.orderId = payload;
    });

    builder.addCase(purchaseGoldenCard.rejected, (state) => {
      state.addHubLoading = false;
    });

    //SUBSCRIPTION BUNDLE
    builder.addCase(
      getTravelutionSubscriptionBundle.fulfilled,
      (state, { payload }) => {
        state.subscriptionBundle = payload;
      }
    );

    builder.addCase(purchaseSubscriptionBundle.pending, (state) => {
      state.addHubLoading = true;
    });
    builder.addCase(
      purchaseSubscriptionBundle.fulfilled,
      (state, { payload }) => {
        state.addHubLoading = false;
        state.orderId = payload;
      }
    );

    // SUPER SALES
    builder.addCase(getSuperSalesLicences.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getSuperSalesLicences.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.hubs = payload;
    });

    builder.addCase(getSuperSalesLicences.rejected, (state) => {
      state.loading = false;
    });

    //PURCHASE SUPER SALES
    builder.addCase(purchaseSuperSales.pending, (state) => {
      state.addHubLoading = true;
    });
    builder.addCase(purchaseSuperSales.fulfilled, (state, { payload }) => {
      state.addHubLoading = false;
      state.orderId = payload;
    });

    builder.addCase(purchaseSuperSales.rejected, (state, { payload }) => {
      state.addHubLoading = false;
    });

    //SUBSCRIPTIONS
    builder.addCase(getSuperSalesSubscriptions.pending, (state) => {
      state.addHubLoading = true;
    });
    builder.addCase(
      getSuperSalesSubscriptions.fulfilled,
      (state, { payload }) => {
        state.addHubLoading = false;
        state.superSalesSubscription = payload;
      }
    );

    builder.addCase(
      getSuperSalesSubscriptions.rejected,
      (state, { payload }) => {
        state.addHubLoading = false;
      }
    );

    // ACCESS PACKS
    builder.addCase(getAccessPacks.pending, (state) => {
      state.loading = true;
      state.hubs = [];
    });
    builder.addCase(getAccessPacks.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.hubs = payload.hubs;
    });

    builder.addCase(getAccessPacks.rejected, (state) => {
      state.loading = false;
    });

    //PURCHASE ACCESS PACK
    builder.addCase(purchaseAccessPack.pending, (state) => {
      state.addHubLoading = true;
    });
    builder.addCase(purchaseAccessPack.fulfilled, (state, { payload }) => {
      state.addHubLoading = false;
      state.orderId = payload;
    });

    builder.addCase(purchaseAccessPack.rejected, (state) => {
      state.addHubLoading = false;
    });

    // VIRTUAL OFFICE

    builder.addCase(buyVirtualOffice.pending, (state) => {
      state.addHubLoading = true;
    });
    builder.addCase(buyVirtualOffice.fulfilled, (state, { payload }) => {
      state.addHubLoading = false;
      state.orderId = payload;
    });

    builder.addCase(buyVirtualOffice.rejected, (state) => {
      state.addHubLoading = false;
    });

    builder.addCase(purchaseSubscriptionBundle.rejected, (state) => {
      state.addHubLoading = false;
    });

    //PURCHASE CARD STEPS
    builder.addCase(setPurchaseCardStep.fulfilled, (state, { payload }) => {
      state.step = payload;
    });

    //SET ORDER STEP
    builder.addCase(setOrderId.fulfilled, (state, { payload }) => {
      state.orderId = payload;
    });
  }
});

// export const { clearHubs } = marketplaceSlice.actions;

export default marketplaceSlice.reducer;
